import { NavLink, Outlet, useLocation } from 'react-router-dom'
import { APP_NAME } from '../lib/constants'
import { useAuth } from '../contexts/AuthContext'

export function Layout() {
  const { user, profile, signOut } = useAuth()
  const location = useLocation()
  const legalSectionActive =
    location.pathname === '/terms' || location.pathname === '/privacy'

  return (
    <div className="app-shell">
      <header className="site-header">
        <div className="container header-inner">
        <NavLink to="/" className="brand" aria-label={`${APP_NAME} home`}>
          <img
            src="/images/logo.png"
            alt=""
            className="brand-logo"
          />
          <span>{APP_NAME}</span>
        </NavLink>

          <nav className="main-nav" aria-label="Main navigation">
            <NavLink to="/" end>
              Home
            </NavLink>
            {user && <NavLink to="/dashboard">My submissions</NavLink>}
            {profile?.role === 'admin' && <NavLink to="/admin">Admin</NavLink>}
            <NavLink
              to="/terms"
              className={legalSectionActive ? 'active' : undefined}
            >
              Terms & Privacy
            </NavLink>
            <NavLink to="/about">About</NavLink>
            {user ? (
              <>
                <NavLink to="/account">Account</NavLink>
                <button className="nav-button" type="button" onClick={() => void signOut()}>
                  Sign out
                </button>
              </>
            ) : (
              <NavLink to="/auth">Sign in</NavLink>
            )}
          </nav>
        </div>
      </header>

      <main className="site-main">
        <Outlet />
      </main>

      <footer className="site-footer">
        <div className="container footer-inner">
          <div>
            <strong>{APP_NAME}</strong>
            <p>A free, private, human first look at scientific work.</p>
          </div>
          <div className="footer-links">
            <NavLink to="/terms">Terms of service</NavLink>
            <NavLink to="/privacy">Privacy notice</NavLink>
          </div>
        </div>
      </footer>
    </div>
  )
}
